import { jsx as _jsx } from "react/jsx-runtime";
import { Step, StepLabel, Stepper } from '@mui/material';
import { noop } from 'ts-essentials';
import { useNavigateBack } from 'shared/hooks/router';
const steps = [
    { id: 0, name: 'Выбор тарифа' },
    { id: 1, name: 'Оформление доставки' },
];
export function SimOrderStepper(props) {
    const { step_id } = props;
    const onClickBack = useNavigateBack();
    return (_jsx(Stepper, { activeStep: step_id, sx: { my: 2 }, alternativeLabel: true, children: steps.map(({ id, name }) => (_jsx(Step, { onClick: id == 0 && step_id != 0 ? onClickBack : noop, children: _jsx(StepLabel, { sx: { '& .MuiStepLabel-label': { mt: 1 } }, children: name }) }, id))) }));
}
